module.exports = {
          srcSet: __webpack_public_path__ + "a7fdc27d2b6f29646d6d3cff1de76903-1110.png"+" 1110w",
          images:[ {path: __webpack_public_path__ + "a7fdc27d2b6f29646d6d3cff1de76903-1110.png",width: 1110,height: 298}],
          src: __webpack_public_path__ + "a7fdc27d2b6f29646d6d3cff1de76903-1110.png",
          toString:function(){return __webpack_public_path__ + "a7fdc27d2b6f29646d6d3cff1de76903-1110.png"},
          
          width: 1110,
          height: 298
        }